import cn from 'classnames'
import { FC } from 'react'

import styles from './Marker.module.scss'

interface IMarkerProps {
  value: number
}

export const Marker: FC<IMarkerProps> = ({ value }) => {
  return (
    <div
      className={cn(styles.root, {
        [styles.red]: value < 90,
        [styles.yellow]: value >= 90 && value < 98,
        [styles.green]: value >= 98,
      })}
    />
  )
}
